<template>
    <v-container class="fill-height" fill-height>
        <v-card class="" height="100%" flat> 
            <v-row allign='center' justify="center" >
                <v-col cols="12" sm="12" md="6">        
                    <v-img src="/404.svg"></v-img>
                </v-col>
                <v-col cols="12" sm="12" md="6" class="mx-auto">
                    <v-container fluid class="fill-height">
                    <v-row justify-center align="center" justify="center">
                    <v-card-text class="font-weight-black">Hey! It seems you are lost. Go back hom below</v-card-text>
                    </v-row>
                    
                    </v-container>
                </v-col>
            </v-row>
            <v-card-text class="text-center">
                <v-btn dark color="rgba(98, 174, 50, 0.7)" to="/dashboard"><v-icon left>mdi-chevron-left</v-icon>GO BACK HOME</v-btn>
            </v-card-text>
        
        </v-card>
    </v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>